import { Brands } from '../../../config/brands';
import mainTheme from '../theme';

const theme = {
  ...mainTheme,
  name: Brands.AIT,
  COLORS: {
    ...mainTheme.COLORS,
    primary: '#C51718',
    secondary: '#8AA2B0',
  },
};

export default theme;
